import React from "react";
import "../styles/HomeClients.css";

function HomeClients() {
  const allClientLogos = [
    { src: "/clients/Precise-chemi-2.png", name: "Precise Chemi Pharma" },
    { src: "/clients/Suzlon-3-png.png", name: "Suzlon Energy" },
    { src: "/clients/Everest-industries-4-png.png", name: "Everest India Industries" },
    { src: "/clients/TKSL-kolhapur-stell.png", name: "Kolhapur Steel (Kirloskar Groups)" },
    { src: "/clients/Ghatge-patil-10.png", name: "Ghatge Patil Industries" },
    { src: "/clients/Nelson-Global-1-png.png", name: "Nelson Global India Ltd." },
    { src: "/clients/Zobele-7.png", name: "Zobele India Pvt. Ltd." },
    { src: "/clients/kirloskar-5-png.png", name: "Kirloskar" },
    { src: "/clients/rockwool-11-png.png", name: "Rock Wool India Ltd." },
    { src: "/clients/polycab-wires-13-png.png", name: "Polycab Wires Pvt Ltd" },
    { src: "/clients/Kirloskar-brothers-9-png.png", name: "Kirloskar Brothers Ltd." },
    { src: "/clients/ebix-cash.png", name: "EbixCash Global Services Pvt Ltd." },
    { src: "/clients/Menon-and-menon-8-png.png", name: "Menon and Menon Ltd." },
    { src: "/newlyaddedclients/supreme-1.png", name: "Supreme" },
    { src: "/newlyaddedclients/indocount-1.png", name: "Indocount" },
    { src: "/newlyaddedclients/Mantri-metallics.png", name: "Mantri Metallics Private Limited" },
    { src: "/newlyaddedclients/Mantri-auto.png", name: "Mantri Auto Components Private Limited" },
    { src: "/newlyaddedclients/Nirmal-Poly-Plastic.png", name: "Nirmal Poly Plastic Private Limited" },
    { src: "/newlyaddedclients/Papro-industries.png", name: "Papro Industries Private Limited" },
    { src: "/newlyaddedclients/Kinet-Railway-Solutions-1.png", name: "Kinet Railway Solutions Private Ltd"}
  ];

  // Duplicate logos array for continuous scrolling effect
  const duplicatedLogos = [...allClientLogos, ...allClientLogos];

  return (
    <section className="our-clients-section">
      <h2 className="section-title">Our Clients</h2>

      <div className="logos-slider">
        <div className="logos-track">
          {duplicatedLogos.map((logo, index) => (
            <img
              key={`client-logo-${index}`}
              src={logo.src}
              alt={`${logo.name} logo`}  
              title={logo.name}    
              loading="lazy"       
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeClients;
